import React from 'react';
import { useSelector } from 'react-redux';

import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  name: '',
};

export const FormGeneral = ({
  data,
  onChange,
  isLoading
}) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    {
      name
    },
    setState,
  ] = React.useState(initialState);

  React.useEffect(() => {
    const state = {
      name
    };

    onChange(state);
  }, [
    name
  ]);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      name: data?.name
    }));
  }, [data]);

  return (
    <div className='mt-3 border-bottom'>
      {isLoading ? (
        <SkeletonsForm count={1} />
      ) : (
        <Form.Input
          required
          label="Name"
          type="text"
          value={name}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              name: e.target.value,
            }))
          }
          error={StateForm?.errors?.name}
        />
      )}
    </div>
  );
};
